import {UPDATE_AVAILABLE_LANGUAGES, UPDATE_PLAYER_DEFAULT_LABELS} from '../actions/language';
import {LanguageReducerType} from '../actions/types/language.types';

export interface LanguageReducerState {
    playerDefaultLabels: Record<string, string>[];
    availableLanguages: {code: string}[];
}
export const preloadedState = {
    playerDefaultLabels: [],
    availableLanguages: [],
};

export const languageReducer = (state: LanguageReducerState = preloadedState, action: LanguageReducerType): LanguageReducerState => {
    switch (action.type) {
        case UPDATE_PLAYER_DEFAULT_LABELS:
            return {...state, playerDefaultLabels: action.labels};
        case UPDATE_AVAILABLE_LANGUAGES:
            return {...state, availableLanguages: action.availableLanguages};
        default:
            return {...state};
    }
};
